module.exports = __webpack_public_path__ + "img/apple_music.0a13168.png";